import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.css']
})
export class ErrorPageComponent implements OnInit {

  msg: string = "";
  constructor(public router: Router, public route: ActivatedRoute) {
    this.msg = this.route.snapshot.paramMap.get('id')
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/error-page/error-page.component.ts